<template>
    <div class="goodsExtensionInsuranceDialog">
        <p class="goodsExtensionInsuranceTit">
            <span class="blueTit">{{$t('message.valueAddedService')}}&ensp;&ensp;{{$t('message.goodsExtensionInsurance')}}：</span>
            <span>{{$t('message.insuranceTips1')}}</span>
        </p>
        <div class="insuranceItemBox">
            <div :class="{definitePlan:definitePlan,insuranceItem:true,active:activePlan ==='1'}"
                 @click="insuranceItemClick('1')">
                <p class="insuranceTitle">{{$t('message.schemeOne')}}</p>
                <table class="itemTable" border="1">
                    <tr>
                        <td>{{$t('message.compensationRatio')}}</td>
                        <td>{{$t('message.theFreight')}} {{insuranceInfo.plan1.payoutRatio}}%</td>
                    </tr>
                    <tr>
                        <td>{{$t('message.rate')}}</td>
                        <td>{{insuranceInfo.plan1.costRatio}}%</td>
                    </tr>
                    <tr>
                        <td>{{$t('message.premium')}}</td>
                        <td>{{$t('message.predict')}} {{insuranceInfo.plan1.insuranceFee}} {{$t('message.yuan')}}</td>
                    </tr>
                </table>
            </div>
            <div :class="{definitePlan:definitePlan,insuranceItem:true,active:activePlan ==='2'}"
                 @click="insuranceItemClick('2')">
                <p class="insuranceTitle">{{$t('message.schemeTwo')}}</p>
                <table class="itemTable" border="1">
                    <tr>
                        <td>{{$t('message.compensationRatio')}}</td>
                        <td>{{$t('message.theFreight')}} {{insuranceInfo.plan2.payoutRatio}}%</td>
                    </tr>
                    <tr>
                        <td>{{$t('message.rate')}}</td>
                        <td>{{insuranceInfo.plan2.costRatio}}%</td>
                    </tr>
                    <tr>
                        <td>{{$t('message.premium')}}</td>
                        <td>{{$t('message.predict')}} {{insuranceInfo.plan2.insuranceFee}} {{$t('message.yuan')}}</td>
                    </tr>
                </table>
            </div>
            <div :class="{definitePlan:definitePlan,insuranceItem:true,active:activePlan ==='3'}"
                 @click="insuranceItemClick('3')">
                <p class="insuranceTitle">{{$t('message.schemeThird')}}</p>
                <table class="itemTable" border="1">
                    <tr>
                        <td>{{$t('message.compensationRatio')}}</td>
                        <td>{{$t('message.theFreight')}} {{insuranceInfo.plan3.payoutRatio}}%</td>
                    </tr>
                    <tr>
                        <td>{{$t('message.rate')}}</td>
                        <td>{{insuranceInfo.plan3.costRatio}}%</td>
                    </tr>
                    <tr>
                        <td>{{$t('message.premium')}}</td>
                        <td>{{$t('message.predict')}} {{insuranceInfo.plan3.insuranceFee}} {{$t('message.yuan')}}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="tips">{{$t('message.insuranceTips2')}}</div>
        <div class="tips">{{$t('message.insuranceTips3')}}</div>
        <div class="userInfo">
            <div v-if="userInfo.userType === '0'">
                <p>
                    <span>{{$t('message.companyName')}}：</span>
                    <span>{{userInfo.companyName}}</span>
                </p>
                <p>
                    <span>{{$t('message.creditCode')}}：</span>
                    <span>{{userInfo.taxId}}</span>
                </p>
            </div>
            <div v-if="userInfo.userType === '1'">
                <p>
                    <span>{{$t('message.realName')}}：</span>
                    <span>{{userInfo.realName}}</span>
                </p>
                <p>
                    <span>{{$t('message.IDCard')}}：</span>
                    <span>{{userInfo.idCard}}</span>
                </p>
            </div>
        </div>
        <div v-show="activePlan" style="text-align: right;">
            <el-button v-if="!definitePlan"
                       size="mini"
                       type="primary"
                       @click="confirmClick();$bigData('insuranceConfirm', '货延险确认', orderBillCode + '+' + activePlan)">{{$t('message.affirm')}}
            </el-button>
            <el-button v-else
                       size="mini"
                       type="primary"
                       disabled>{{$t('message.affirmed')}}</el-button>
            <el-button size="mini" @click="reselectClick();$bigData('insuranceCancel', '重新选择', orderBillCode)">
                {{$t('message.selectAgain')}}
            </el-button>
        </div>
        <GoodsExtensionInsuranceProtocolDialog
                :callback="protocolCallback"
                :cancelCallback="protocolCancelCallback"
                :show="isShowProtocolDialog">
        </GoodsExtensionInsuranceProtocolDialog>
    </div>
</template>

<script>

    import GoodsExtensionInsuranceProtocolDialog
        from '@/components/personalCenter/GoodsExtensionInsuranceProtocolDialog.vue';// 货延险协议弹窗

    export default {
        name: 'GoodsExtensionInsuranceDialog',// 货延险弹窗
        components: {
            GoodsExtensionInsuranceProtocolDialog
        },
        props: {
            // 货延险信息
            insuranceInfo: {
                type: Object,
                default: () => ({
                    plan1: {
                        payoutRatio: '',// 赔付比例
                        costRatio: '',// 费率
                        insuranceFee: ''// 保费
                    },
                    plan2: {
                        payoutRatio: '',// 赔付比例
                        costRatio: '',// 费率
                        insuranceFee: ''// 保费
                    },
                    plan3: {
                        payoutRatio: '',// 赔付比例
                        costRatio: '',// 费率
                        insuranceFee: ''// 保费
                    }
                })
            },
            // 用户信息
            userInfo: {
                type: Object,
                default: () => ({
                    userType: '0',// 0-企业用户、1-合伙人
                    // 企业用户数据（若非企业用户 无需返回）
                    companyName: '',// 企业名称
                    taxId: '',// 信用代码（税号）
                    // 合伙人数据（若非合伙人 无需返回）
                    realName: '',// 真实姓名
                    idCard: ''// 身份证
                })
            },
            // 回调fn
            callback: {
                type: Function,
                default: () => {
                }
            },
            // 初始化
            init: {
                type: Number,
                default: -1
            },
            // 托单号
            orderBillCode: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                activePlan: '',// 选中的货延险
                isShowProtocolDialog: -1,// 显示协议弹窗
                definitePlan: false,// 是否锁定方案
            };
        },
        watch: {
            // 初始化
            init() {
                this.reselectClick();// 重新选择
            }
        },
        methods: {
            // 货延险方案切换
            insuranceItemClick(plan) {
                // 已锁定无法点击
                if (this.definitePlan) {
                    return;
                }
                this.activePlan = plan;
            },
            // 重新选择点击
            reselectClick() {
                this.definitePlan = false;// 解锁方案
                this.activePlan = '';
                this.callback(this.activePlan);// 执行回调
            },
            // 点击确认打开协议弹窗
            confirmClick() {
                this.isShowProtocolDialog = +new Date();
            },
            // 点击协议确认回调
            protocolCallback() {
                this.definitePlan = true;// 锁定方案
                this.callback(this.activePlan);// 执行回调
            },
            // 点击协议取消回调
            protocolCancelCallback() {
                this.reselectClick();// 重新选择
            }
        }

    };
</script>

<style lang="scss" scoped>
    .goodsExtensionInsuranceDialog {
        position: relative;
        box-sizing: border-box;
        width: 610px;
        padding: 10px;

        .blueTit {
            margin: 0 0 15px 0;
            font-size: 13px;
            color: #2ea7e0;
        }

        .insuranceItemBox {
            display: flex;
            justify-content: space-around;

            .insuranceItem {
                width: calc(33.3% - 8px);
                cursor: pointer;

                &:not(.definitePlan):hover {
                    .itemTable {
                        border: 1px solid #2ca6e0;
                    }
                }

                &.active {
                    .insuranceTitle {
                        color: #2ca6e0;
                    }

                    .itemTable {
                        background-color: #e3eff5;
                        border: 1px solid #2ca6e0;
                        box-shadow: 0 2px 5px 1px #c1c1c1;
                    }
                }

                &.definitePlan {
                    cursor: not-allowed;
                }

                .insuranceTitle {
                    margin: 16px 0 5px 0;
                    font-size: 12px;
                }

                .itemTable {
                    tr {
                        border: #b3b3b3;
                    }

                    width: 100%;
                    height: 86px;
                    border-collapse: collapse;
                    background-color: #f7f7f7;
                    border: 1px solid #b3b3b3;
                    transition: all 0.25s;
                }
            }
        }

        .tips {
            margin: 10px 0;
            color: red;
        }

        .userInfo {
            p {
                margin: 8px 0;
            }
        }
    }
</style>
